import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=d57704fa&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=d57704fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57704fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d57704fa')) {
      api.createRecord('d57704fa', component.options)
    } else {
      api.reload('d57704fa', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=d57704fa&scoped=true&", function () {
      api.rerender('d57704fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GkDry5jXXL5o/JS/comp/SearchFilterTokens.vue"
export default component.exports